'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from './navBar';
import SideMenu from './sideMenu';
import ReportHeader from './reportComponents/reportHeader';
import ReportBody from './reportComponents/reportBody';
import reportAction from '../actions/reportAction';
import reportStore from '../stores/reportStore';
import filterAction from '../actions/filterAction';
import filterStore from '../stores/filterStore';
import menuAction from '../actions/menuAction';
import userStore from '../stores/userStore';
import Loading from './loading';

class Report extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.state = {
            reports: reportStore.getState().reports,
            staffs: filterStore.getState().staffs,
            
            processingFilter: filterStore.getState().processing,
            iniLoadStaff: filterStore.getState().iniLoadStaff,
            iniLoadTeamMember: filterStore.getState().iniLoadTeamMember,
            teamMember: filterStore.getState().teamMember,

            teamCondo: filterStore.getState().teamCondo,
            iniLoadCondo: filterStore.getState().iniLoadTeamCondo,
            condos: filterStore.getState().condos,
            iniLoadCondo: filterStore.getState().iniLoadCondo,
            processing: reportStore.getState().processing,

            permission: userStore.getState().permission,
           
            userId: userStore.getState().staffId,
        };
    }
    componentWillMount() {

    }
    componentDidMount() {
        reportStore.listen(this.onChange);
        filterStore.listen(this.onFilterChange);
        userStore.listen(this.onUserChange);
        menuAction.pageNumber(4);
        if (!this.state.processingFilter && !this.state.iniLoadStaff) {
            filterAction.processing(true);
            filterAction.getEmployee();
        }
        if(!this.state.iniLoadTeamCondo){
            filterAction.getTeamCondo();
        }
        if (!this.state.iniLoadCondo) {
            //getMCST first
            filterAction.processing(true);
            filterAction.getCondoList();
        }
        if(!this.state.iniLoadTeamMember){
            filterAction.getTeamMember();
        }

    }
    componentWillUnmount() {
        reportStore.unlisten(this.onChange);
        filterStore.unlisten(this.onFilterChange);
        userStore.unlisten(this.onUserChange);
    }
    onUserChange =(state)=>{
        this.setState({
            permission:state.permission,
           
            userId:state.staffId,
        })
    }
    onFilterChange(state){
        this.setState({
            staffs: state.staffs,
            processingFilter: state.processing,
            iniLoadStaff: state.iniLoadStaff,
            iniLoadTeamCondo: state.iniLoadTeamCondo,
            teamCondo: state.teamCondo,
            iniLoadTeamMember: state.iniLoadTeamMember,
            teamMember: state.teamMember,
            iniLoadCondo: state.iniLoadCondo,
            condos: state.condos,
        });
    }
    onChange(state) {
        this.setState({
            reports: state.reports,
            processing: state.processing,
        });
    }

    render() {
        let {userId, condos, teamCondo} = this.state;
        if(userId == "ITG001"){
            condos = [{
                condoName: "Thomson Grand",
                mcst: "4309"
            }];
            teamCondo = [{
                condoName: "Thomson Grand",
                mcst: "4309"
            }];
        }
        return (
            <div className="container-fluid content">
                <div className="row">
                    <NavBar {...this.props} />
                    <SideMenu {...this.props} />
                    <div className=" col-md-10  col-sm-8 atd">
                        <ReportHeader staffs={this.state.staffs} condos={condos} iniLoad={this.state.iniLoad} 
                            teamMember={this.state.teamMember} teamCondo={teamCondo} />
                        <div className="divider"></div>
                        <ReportBody reports={this.state.reports} {...this.props} />
                    </div>
                </div>
                <Loading processing={this.state.processing || this.state.processingFilter} />
            </div>
        );
    }
}
export default Report;


// WEBPACK FOOTER //
// ./app/components/report.js